import { render, staticRenderFns } from "./setupPassword.vue?vue&type=template&id=21adecb7&scoped=true"
import script from "./setupPassword.vue?vue&type=script&lang=js"
export * from "./setupPassword.vue?vue&type=script&lang=js"
import style0 from "./setupPassword.vue?vue&type=style&index=0&id=21adecb7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adecb7",
  null
  
)

export default component.exports